/**
 * Единая точка чтения адресов бэкендов.
 *
 * Ровно две переменные, без синонимов и legacy-фолбэков:
 * - VITE_BFF_SERVICE_URL — Core/BFF (data API, process API);
 * - VITE_AI_SERVICE_URL  — AI-сервис (чат, SSE, загрузка файлов).
 *
 * Приоритет: runtime (env.js, пишется docker-entrypoint.sh при старте контейнера)
 * → build-time (import.meta.env, запекается vite) → localhost-дефолт.
 * Дефолт намеренно локальный: если переменная не доехала до стенда, приложение
 * заметно упадёт на localhost, а не уйдёт молча в чужой контур.
 */
interface RuntimeConfig {
  VITE_BFF_SERVICE_URL?: string;
  VITE_AI_SERVICE_URL?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

const runtimeConfig: RuntimeConfig =
  typeof window === 'undefined' || typeof window.__APP_CONFIG__ === 'undefined'
    ? {}
    : window.__APP_CONFIG__;

const getRuntimeValue = (...values: Array<string | undefined>): string | undefined => {
  return values.find((value) => typeof value === 'string' && value.trim() !== '');
};

export const VITE_BFF_SERVICE_URL =
  getRuntimeValue(
    runtimeConfig.VITE_BFF_SERVICE_URL,
    import.meta.env.VITE_BFF_SERVICE_URL
  ) || 'http://localhost:5000';

export const VITE_AI_SERVICE_URL =
  getRuntimeValue(
    runtimeConfig.VITE_AI_SERVICE_URL,
    import.meta.env.VITE_AI_SERVICE_URL
  ) || 'http://localhost:8000';
